export default __webpack_public_path__ + "static/media/Address.2d421268.png";